import { useCallback } from 'react';
import { useGetFolderPermissionsLazyQuery } from '../gql/generated/GetFolderPermissions';

/**
 * Returns a callback that warms the Apollo cache with a folder's permissions.
 *
 * Folder permissions are fetched per-folder and are not preloaded for the child
 * folders shown in a listing, so the first read (e.g. when a context menu opens)
 * incurs a network round-trip. Calling this on hover-intent lets the permission
 * resolve before it's needed. It's a no-op when the data is already cached
 * (cache-first) and when no `folderId` is provided.
 */
export function usePrefetchFolderPermissions() {
  const [prefetch] = useGetFolderPermissionsLazyQuery();

  return useCallback(
    (folderId: string | undefined) => {
      if (!folderId) return;
      prefetch({ variables: { folderId } });
    },
    [prefetch]
  );
}
